import React from "react";
import { Button } from "react-bootstrap";
import CreateUserModal from "./usersPage/CreateUserModal";
import UsersList from "./usersPage/UsersList";
import useUsersPageController from "./usersPage/useUsersPageController";

export default function UsersPage() {
  const {
    t,
    users,
    loading,
    showCreate,
    creating,
    createErr,
    createForm,
    openCreate,
    closeCreate,
    handleCreateChange,
    handleCreateUser,
    handleUserClick
  } = useUsersPageController();

  return (
    <div>
      <div className="container d-xl-block">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h1 className="mb-0">{t("usersTitle")}</h1>
          <Button variant="success" onClick={openCreate}>
            + {t("addUser")}
          </Button>
        </div>

        <UsersList users={users} t={t} loading={loading} onUserClick={handleUserClick} />

        <CreateUserModal
          show={showCreate}
          creating={creating}
          error={createErr}
          form={createForm}
          t={t}
          onClose={closeCreate}
          onChange={handleCreateChange}
          onSubmit={handleCreateUser}
        />
      </div>
    </div>
  );
}
